import IListPreference from "@/models/list-preference/IListPreference";

export default class UserListPreference implements IListPreference {

	public reset(): void {
		//do nothing
	}

}
